export default __webpack_public_path__ + "static/60-sets-banner-desktop-f57609a78dcce57cc9a1cdc88666138f.webp";